import { render } from "./ListsSG.vue?vue&type=template&id=7c50863e&scoped=true"
import script from "./ListsSG.vue?vue&type=script&lang=js"
export * from "./ListsSG.vue?vue&type=script&lang=js"

import "./ListsSG.vue?vue&type=style&index=0&id=7c50863e&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c50863e"]])

export default __exports__